module.exports = __webpack_public_path__ + "img/08.c277aaed.jpg";